import { useEffect, useState } from "react";
import { connect } from "react-redux";
import useMedia from "use-media";

import { CheckboxListBox } from "../molecules/checkboxListBox";
import { ModalClose } from "../atoms/modalClose";
import { Button } from "../atoms/button";

const StartTimeContainer = (props) => {
    const { startTime, course, setStartTime, state, onClickOpenStartTimeWindow } = props;

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [courseCount, setCourseCount] = useState(4);

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useEffect(() => {
        startTime.forEach((c)=>{
            document.getElementById(c.value).checked = c.checked;
        });
        let count = 0;
        for (let i in course) {
            if (course[i].checked === true) {
                count += 1;
            }
        }
        setCourseCount(count);
    }, [state]);

    // 選択した開始時刻をstoreに保存
    const onClickDecision = () => {
        const arry = [];
        const elements = document.getElementsByClassName("start_time");
        for (let i in elements) {
            if (elements[i].checked === true) {
                arry.push(elements[i].value);
            }
        }

        for (let i in startTime) {
            let index = arry.indexOf(startTime[i].id);
            if (index >= 0) {
                startTime[i].checked = true;
            } else {
                startTime[i].checked = false;
            }
        }
        setStartTime(startTime);
        onClickOpenStartTimeWindow();
    };

    return (
        <div style={state ? style.popupIsShow : style.popup} id="js-popup">
            <div style={isMobilePhone ? style.popupInnerMobile : style.popupInner}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickOpenStartTimeWindow}/>
                <h4 style={isMobilePhone ? style.popupInnerTextSp : style.popupInnerText}>スタート時間</h4>
                <CheckboxListBox
                    divStyle={isMobilePhone ? style.divStyleMobile : style.divStyle}
                    data={startTime}
                    checkAreaStyle={style.areaStyleCheckArea} />
                <div style={isMobilePhone ? style.buttonAreaMobile : style.buttonArea}>
                    <Button buttonText="決 定" className={"selectBtn"} onClick={onClickDecision} />
                </div>
            </div>
            <div style={style.blackBackground} id="js-black-bg"></div>
        </div>
    );
};
const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "40%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom:"1px solid #eee",
        margin:0,
        padding:"20px 0px 20px 0px"
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "40px 0px",
    },
    buttonAreaMobile: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0px",
    },
    deleteCriteria: {
        color: "#adadad",
        textAlign: "right",
        textDecoration: "underline",
    },
    // CheckboxListBoxコンポーネントに引数として渡すスタイル情報
    divStyle: {
        display: "flex",
        flexWrap: "wrap",
        width: "80%",
        textAlign: "left",
        alignContent: "flex-start",
        margin: "60px 20px 30px 70px",
        fontSize: "small",
    },
    divStyleMobile: {
        display: "flex",
        flexWrap: "wrap",
        textAlign: "left",
        alignContent: "flex-start",
        margin: "20px 0px 0px 50px",
        fontSize: "small",
    },
    // エリアの各チェックボックス要素の並び(2列)
    areaStyleCheckArea: {
        width: "33%",
        paddingBottom: "25px",
    },
}

const mapStateToProps = (state) => {
    return {
        startTime: state.startTime,
        course: state.course,
    };
};

const mapDisptchToProps = (dispatch) => {
    return {
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        }
    };
};

export default connect(mapStateToProps, mapDisptchToProps)(StartTimeContainer);